export const chargeInfoShow: any = {
  pageTitle: "請求内容確認",
  summaryPrice: "合計料金",
};
